import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from "./register/register.component";
import { ManageFleetComponent } from './pages/managefleet/managefleet.component';
import { PagesComponent } from './pages/pages.component';
import { AddfleetComponent } from './pages/managefleet/addfleet/addfleet.component';
import { AllfleetComponent } from './pages/managefleet/allfleet/allfleet.component';
import { AddtransporterComponent } from './pages/transporter/addtransporter/addtransporter.component';
import { AlltransporterComponent } from './pages/transporter/alltransporter/alltransporter.component';
import { TransporterComponent } from './pages/transporter/transporter.component';
import { UserandroleComponent } from './pages/userandrole/userandrole.component';
import { AdminComponent } from './pages/admin/admin.component';
import { AlluserroleComponent } from './pages/userandrole/alluserrole/alluserrole.component';
import { AdduserComponent } from "./pages/userandrole/adduser/adduser.component";
import { OrderComponent } from './pages/order/order.component';
import { SchedulingandplanningComponent } from './pages/schedulingandplanning/schedulingandplanning.component';
import { CreatetriptableComponent } from './pages/schedulingandplanning/createtriptable/createtriptable.component';
import { EdittriptableComponent } from './pages/schedulingandplanning/edittriptable/edittriptable.component';
import { ScheduletriptableComponent } from './pages/schedulingandplanning/scheduletriptable/scheduletriptable.component';
import { FleetComponent } from './pages/fleet/fleet.component';
import { TripComponent } from './pages/trip/trip.component';
import { TripmapviewComponent } from './pages/trip/tripmapview/tripmapview.component';
import { TriplistviewComponent } from './pages/trip/triplistview/triplistview.component';
import { OrdermapviewComponent } from './pages/order/ordermapview/ordermapview.component';
import { OrderlistviewComponent } from './pages/order/orderlistview/orderlistview.component';
import { FleetmapviewComponent } from './pages/fleet/fleetmapview/fleetmapview.component';
import { FleetlistviewComponent } from './pages/fleet/fleetlistview/fleetlistview.component';
import { HomeComponent } from './pages/home/home.component';
import { SchedulefleetComponent } from './pages/managefleet/schedulefleet/schedulefleet.component';
import { SearchresultComponent } from './pages/searchresult/searchresult.component';
import {TripanalyticsComponent} from './pages/tripanalytics/tripanalytics.component';
import { OrderreportComponent } from './pages/orderreport/orderreport.component';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { SnreportComponent } from './pages/snreport/snreport.component';
import { TripdetailreportComponent } from './pages/tripdetailreport/tripdetailreport.component';
import { PickupsComponent } from './pages/pickups/pickups.component';

import { AuthGuard } from './auth/auth.guard';
import { ManagecustomerComponent } from './pages/managecustomer/managecustomer.component';
import { AllcustomersComponent } from './pages/managecustomer/allcustomers/allcustomers.component';
import { AddcustomerComponent } from './pages/managecustomer/addcustomer/addcustomer.component';
import { TransportrateComponent } from './pages/transportrate/transportrate.component';
import { TimelineComponent } from './pages/timeline/timeline.component';
import { UserreportComponent } from './pages/userreport/userreport.component';
import { SummaryReportComponent } from './pages/summary-report/summary-report.component'
import { RunnerboyreportComponent } from './pages/runnerboyreport/runnerboyreport.component';
import { MarketingboyreportComponent } from './pages/marketingboyreport/marketingboyreport.component';
import { HomecollectionboyreportComponent } from './pages/homecollectionboyreport/homecollectionboyreport.component';
import { DiagnosticSummaryReportComponent } from './pages/diagnostic-summary-report/diagnostic-summary-report.component'
import { OndutyoffdutyreportComponent } from './pages/ondutyoffdutyreport/ondutyoffdutyreport.component';
import { OrderdailyreportComponent } from './pages/orderdailyreport/orderdailyreport.component';
import { ManageAuditTrailComponent } from './pages/manage-audit-trail/manage-audit-trail.component';
import { OrdertrackingComponent } from './pages/order/ordertracking/ordertracking.component'

const routes: Routes = [
  {
    path: '', component: PagesComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', component: HomeComponent },
      {
        path: 'managefleet', component: ManageFleetComponent,
        children: [
          { path: '', component: AllfleetComponent },
          { path: 'addnewfleet', component: AddfleetComponent },
          // { path: 'schedulefleet', component: SchedulefleetComponent }
        ]
      },
      {
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            except: ['Store_Manager','Home_Collection_Admin', 'Runner_Boy_Admin']
          }
        },
        path: 'dashboard', component: DashboardComponent,
      },
      {
        path: 'transporter', component: TransporterComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: ['Admin','CXO', ]
          }
        },
        children: [
          { path: '', component: AlltransporterComponent },
          { path: 'addnewtransporter', component: AddtransporterComponent }
        ]
      },
      {
        path: 'managecustomers', component: ManagecustomerComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: ['Admin','CXO', ]
          }
        },
        children: [
          { path: '', component: AllcustomersComponent },
          { path: 'addcustomer', component: AddcustomerComponent }
        ]
      },
      {
        path: 'userandrole', component: UserandroleComponent,
        children: [
          { path: '', component: AlluserroleComponent },
          { path: 'addnewuser', component: AdduserComponent },
        ]
      },
     
      {
        path: 'order', component: OrderComponent,
        data: {
          permissions: {
            except: ['Home_Collection_Admin', 'Runner_Boy_Admin']
          }
        },
        children: [
          {
            path: '', component: OrderlistviewComponent
          },
          {
            path: 'ordermapview', component: OrdermapviewComponent
          }
        ]
      },
      {
        path: 'fleet', component: FleetComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            except: ['Store_Manager','Home_Collection_Admin', 'Runner_Boy_Admin']
          }
        },
        children: [
          {
            path: '', component: FleetlistviewComponent
          },
          {
            path: 'fleetmapview', component: FleetmapviewComponent
          }
        ]
      },
      {
        path: 'trip', component: TripComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            except: ['Home_Collection_Admin', 'Runner_Boy_Admin']
          }
        },
        children: [
          {
            path: '', component: TriplistviewComponent
          },
          {
            path: 'tripmapview', component: TripmapviewComponent
          }
        ]
      },

      {
        path: 'routes', component: TimelineComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            except: ['Store_Manager','Home_Collection_Admin', 'Runner_Boy_Admin']
          }
        },
      },

      {
        path: 'tripanalytics', component: TripanalyticsComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            except: ['Store_Manager','Home_Collection_Admin', 'Runner_Boy_Admin']
          }
        }
      },
      {
        path: 'tripdetailreport', component: TripdetailreportComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            except: ['Store_Manager','Home_Collection_Admin', 'Runner_Boy_Admin']
          }
        }
      },
      {
        path: 'orderreport', component: OrderreportComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            except: ['Store_Manager','Home_Collection_Admin', 'Runner_Boy_Admin']
          }
        }
      },
      {
        path: 'orderdailyreport', component: OrderdailyreportComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            except: ['Store_Manager','Home_Collection_Admin', 'Runner_Boy_Admin']
          }
        }
      },
      {
        path: 'userreport', component: UserreportComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            except: ['Store_Manager','Home_Collection_Admin', 'Runner_Boy_Admin']
          }
        }
      },
      {
        path: 'runnerboyreport', component: RunnerboyreportComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            except: ['Store_Manager','Home_Collection_Admin', 'Runner_Boy_Admin']
          }
        }
      },
      {
        path: 'marketingboyreport', component: MarketingboyreportComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            except: ['Store_Manager','Home_Collection_Admin', 'Runner_Boy_Admin']
          }
        }
      },
      {
        path: 'homecollectionboyreport', component: HomecollectionboyreportComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            except: ['Store_Manager','Home_Collection_Admin', 'Runner_Boy_Admin']
          }
        }
      },
      {
        path: 'ondutyoffdutyreport', component: OndutyoffdutyreportComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            except: ['Store_Manager','Home_Collection_Admin', 'Runner_Boy_Admin']
          }
        }
      },
      {
        path: 'usersummary', component: DiagnosticSummaryReportComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            except: ['Store_Manager','Home_Collection_Admin', 'Runner_Boy_Admin']
          }
        }
      },
      {
        path: 'summaryreport', component: SummaryReportComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: ['Admin']
          }
        }
      },
      {
        path: 'snreport', component: SnreportComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            except: ['Store_Manager','Home_Collection_Admin', 'Runner_Boy_Admin']
          }
        }
      },
      {
        path: 'scheduling', component: SchedulingandplanningComponent,
        children: [
          {
            path: '', component: CreatetriptableComponent,
               canActivate: [NgxPermissionsGuard],
            data: {
              permissions: {
                only: ['Admin','CXO','Warehouse_Manager', 'Home_Collection_Admin', 'Runner_Boy_Admin','Store_Manager']
              }
            }
          },
          {
            path: 'edittrips', component: EdittriptableComponent,
               canActivate: [NgxPermissionsGuard],
            data: {
              permissions: {
                only: ['Admin','CXO','Warehouse_Manager','Home_Collection_Admin', 'Runner_Boy_Admin','Store_Manager']
              }
            }
          },
          {
            path: 'scheduletrips', component: ScheduletriptableComponent,
               canActivate: [NgxPermissionsGuard],
            data: {
              permissions: {
                only: ['Admin','CXO','Warehouse_Manager','Home_Collection_Admin', 'Runner_Boy_Admin','Store_Manager']
              }
            }
          }
        ]
      },
      {
        path: 'pickups', component: PickupsComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            except: ['Store_Manager']
          }
        }
      },
      {
        path: 'searchresult', component: SearchresultComponent
      },
      {
        path: 'admin', component: AdminComponent,
      },
      {
        path: 'transportrate', component: TransportrateComponent
      },
      {
        path: 'audittrail', component: ManageAuditTrailComponent,
        canActivate: [NgxPermissionsGuard],
        data: {
          permissions: {
            only: ['Admin']
          }
        }
      }
    ]
  },
  { path: 'track/:trackid', component: OrdertrackingComponent },
  { path: 'navbar', component: NavbarComponent },
  { path: 'login', component: LoginComponent, pathMatch: 'full' },
  { path: 'register', component: RegisterComponent },
  { path: '', redirectTo: 'login', pathMatch: 'full' },

];


const config: ExtraOptions = {
  useHash: true,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
